<template>
  <Modal v-model="distributorPlatformConfigModal" :title="$t('key1001837')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="distributorPlatformConfigChange">
    <div class="flex flex-wrap mb20">
      <div class="red-dot width_90">{{ $t('key1002187') }}</div>
      <CheckboxGroup class="flex flex-wrap flex_1" v-model="platformValueList">
        <Checkbox class="mr30 mb15" v-for="item in distributorPlatformList" :label="item.value">{{ item.name }}</Checkbox>
      </CheckboxGroup>
    </div>
    <template #footer>
      <Button @click="distributorPlatformConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="distributorPlatformConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'distributorPlatformConfigModal',
  mixins: [Mixin],
  props: {
    enumData: {
      type: Object,
      default: null
    }
  },
  data() {
    let v = this;
    return {
      distributorPlatformConfigModal: false,
      platformValueList: [],
      distributorPlatformList: [],
      configParamKey: null,
      enumKey: 'DistributorPlatformEnum',
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initDistributorPlatformData(paramKey, paramValue) {
      const obj = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      if (obj) {
        let {distributorPlatformSetSaas} = obj;
        this.distributorPlatformList = distributorPlatformSetSaas.map((val) => {
          return {
            value: val,
            name: this.enumData[`${this.enumKey}_${val}`] || '',
          }
        });
      }
      this.platformValueList = paramValue || [];
      this.configParamKey = paramKey;
      this.distributorPlatformConfigModal = true;
    },
    // 确定
    distributorPlatformConfigBtn() {
      if (this.platformValueList.length === 0) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002186'));
        return false;
      }
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(this.platformValueList),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.distributorPlatformConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    distributorPlatformConfigChange(value) {
      if (!value) {
        this.platformValueList = [];
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
